angular.module('blc').service('quote', quote_service);
quote_service.$inject = ['$interval','$http','$rootScope'];
function quote_service($interval,$http, $rootScope) {
  var that = this;
  this.quote = {
    id:               null,
    dates:            [],
    places:           [],
    geo:              [],
    countries:        [],
    atype:            0,
    car:              null,
    service:          {},
    status:           1,
    agree2news:       true,
    personal:         { name:    null, phone:   null, email:   null, message: null },
// --------------------------------------------------------------------------------------
    recent_cars:      recent_cars,
    country_valid:    country_valid,
    places_formatted: places_formatted,
    reset:            reset,
    submit_quote:     submit_quote,
    update:           save_me,
    goto_search:      goto_search,
    days:             function() { return Math.ceil(this.hours() / 24) },
    hours:            hours,
// --------------------------------------------------------------------------------------
    clear_car:        function() { this.car = null; this.car_id = null; },
    ready:            function() { return this.dates.join('').length>0 && this.places.join('').length>0; },
    url:              function() { return '/search?param_id=' + this.id; },
  };
  this.old_hash = 0; 
  if (ho=location.search.match(/offer=(\w+)/)) {
    this.quote.offer = ho[1];
  }
  var storage_quote = localStorage.getObject('quote');
  if (storage_quote) {
    $.extend(this.quote, storage_quote);
    ga('send','event','quote','restore from localStorage',this.quote.id||'noID')
  }
  if (!this.quote.service.landing_page) {
    if (typeof sessionStorage.landing_page==='undefined') {
      sessionStorage.landing_page = location.href;
    }
    this.quote.service.landing_page = sessionStorage.landing_page;
  }

  if (jsonlddata[1]) { // set quote car from car page
    this.quote.car = {
      id: jsonlddata[1].productID,
      title: jsonlddata[1].name,
      price: jsonlddata[1].offers.price,
      prototype: jsonlddata[1]['@id'],
      image: jsonlddata[1].image
    }      
  }
  $interval(save_me, 1000);

  return this.quote;

  // ------------------------------
  function hours() {
    var daystart   = that.quote.dates[0] || that.quote.dates[1],
        dayend     = that.quote.dates[1] || that.quote.dates[0],
        hours      = moment(dayend).diff(moment(daystart), 'hours');

    return hours > 0 ? hours : 1;
  }

  function goto_search() {
    var valid = validate();
    if (valid===true) {
      location.href = this.url();
      ga('send','event','quote','init search',quote_short(), that.quote.id);
      return true;
    } else {
      $rootScope.$broadcast('generic quote error');
      ga('send','event','quote','error','attempt to search without all data');
      return false; 
    }
  }

  function places_formatted() {
    var pl1 = that.quote.places[0],
        pl2 = that.quote.places[1];
    return [
      typeof pl1=='object' ? ( pl1===null ? '' : pl1.name ) : pl1,
      typeof pl2=='object' ? ( pl2===null ? '' : pl2.name ) : pl2
    ];
  }
  function reset() {
    if (that.quote.status==1) return;
    that.quote.status = 1;
    that.quote.agree2news = false;
    that.quote.dates = [];
    that.quote.places = [];

    that.quote.car = null;
    that.quote.id = null;
  }

  function submit_quote() {
    ga('send', 'event','quote','new',quote_short(), that.quote.id);
    that.quote.status = 2;
    save_me();


    setTimeout(function() { that.quote.reset() }, 2000);

    $.magnificPopup.open({
      mainClass: 'mfp-fade',
      removalDelay: 400,
      overflowY: 'scroll',
      callbacks: {
        afterClose: function() { 
          // this not fire
          ga('send', 'event', 'thank', 'close', quote_short(), that.quote.id);
          setTimeout(function() {location.href = '/bspoke';}, 100);
        },
      },
      items: [
        {
          type: 'inline',
          src: '#thank'
        }
      ]
    })

    $('#thank .wp').addClass('insearch');
    setTimeout(function(){
      $('#thank .wp').removeClass('insearch');
    }, 2000)
    // isMobile() ? window.scrollTo(0, $('#thank').offset().top + 5) : 0;
  }

  function validate() {
    var errors = [];
    if (that.quote.places.join('').length===0) errors.push('places-empty');
    if (that.quote.dates.join('').length===0) errors.push('dates-empty');
    return errors.length>0 ? errors : true;
  }
  function country_valid(country) {
    return true;
    var allowedCountries = 'GB ES DE ES FR PT MC CH LI LU NL BE AT CZ AE IT HU'.toLowerCase().split(' ');
    return allowedCountries.indexOf(country.toLowerCase())>=0;
  }

  function save_me() {
    var new_hash = Hashcode.value(that.quote);
    if (that.old_hash == new_hash) return;
    that.old_hash = new_hash;
    localStorage.setObject('quote', that.quote);

    if (!that.quote.ready()) return;

    if (that.quote.id) {
      $http.patch('/quotes/' + that.quote.id, that.quote).success(function(data, status) {
       // may be it is not needed 
       $.extend(that.quote, data);
      });
      ga('send', 'event', 'quote', 'update', quote_short(),  that.quote.id );
    } else {
      $http.post('/quotes', that.quote).success(function(data, status) {
        $.extend(that.quote, data); // update quote in controller
        ga('send', 'event', 'quote', 'init', quote_short(),  that.quote.id );
      });
    }
  }
  function quote_short() {
    var pl = that.quote.places_formatted().join(':');
    var da = that.quote.dates.join(':');
    return pl+" / "+da;
  }
  function recent_cars(ncars) {
    if (!that.quote.id || !ncars) return [];
    return $http.get('/quotes/'+that.quote.id+'/cars/' + ncars);
  }
}

angular.module('blc').factory('prepare_quote', [ function() {
  var prepare_quote = {
    request: function(config) {
      if (config.url.match(/quote/)) {
        if (!config.data) return config;
        if (config.updating_quote) return config;
        if (typeof config.data.places[0] != 'undefined') {
          config.data.places[0] = typeof config.data.places[0] == 'object' ? config.data.places[0].name : config.data.places[0];
        }
        var pl2 = config.data.places[1];
        if (pl2 && typeof pl2 != 'undefined') {
          config.data.places[1] = typeof pl2 == 'object' ? pl2.name : pl2;
        }
        if (typeof config.data.car != 'undefined' && config.data.car != null) {
          config.data.car_id = typeof config.data.car == 'object' ? config.data.car.id : config.data.car;
        }
        config.data.atype = parseInt(config.data.atype);
        //delete(config.data.car);
        config.updating_quote = true;
      }
      return config;
    },
    response: function(response) {
      if (response.config.url.match(/quote/)) {
        if (response.config.updating_quote) {
          delete(response.config.updating_quote);
        }
      }
      return response;
    }
  };
  return prepare_quote;
}]);

angular.module('blc').config(['$httpProvider', function($httpProvider) { 
  $httpProvider.interceptors.push('prepare_quote'); 
}]);




/*****************
 ** WEBPACK FOOTER
 ** ./gulp/assets/javascripts/quote_service.js
 ** module id = 20
 ** module chunks = 0
 **/